export const AppConstants = {

  TipoDocumento: {
    DNI: 1,
    CARNNET_EXTRANJERIA: 2,
    PASAPORTE: 3
  },
  TipoDocumentoSelect: {
    DNI: "dni",
    CE: "ce",
    PAS: "pas"
  },
  CodigoModulo: {
    //RFTDA: 1,
    WebAdministrativa: 1,
    Reportes: 2
  },
  CodigoOpciones: {
    // Applicaciones: 1,
    // Modulos: 2,
    // Opciones: 3,
    // Acciones: 4,
    // Perfiles: 5,
    // Usuarios: 6,
    // Dispositivos: 7,
    // Sucursales: 8,
    // Reporte: 9,
    Dashboard: 2002211,
    Estadistica: 2002212,
    Exportar: 2002213,
    Parametro: 2002214,
    Multimedia: 2002215,
    Sucursales: 2002216,
    Maquinas: 2002217,
    Logs: 2002218,
    Ventas: 2002219,
    OrdenCompra: 2,
    Clientes: 1
  },
  CodigoAcciones: {
    Limpiar: 1,
    Consultar: 2,
    Nuevo: 3,
    Actualizar: 4,
    Exportar: 5,
    Acceso: 6,
    CopiarPerfil: 7
  },

  Paginado: {
    DEFAULT_PAGE_INDEX_PAGINATION: 0,
    DEFAULT_PAGE_SIZE_PAGINATION: 10
  },

  DateBirthday: {
    DEFAULT_DATE: `${new Date().getDate()}/${('0' + new Date().getMonth() + 1).slice(-2)}/${(new Date().getFullYear() - 18)}`
  },

  Estado: {
    ACTIVO: 1,
    INACTIVO: 0
  },
  BotonModal: {
    BOTON_REGISTRAR: "Agregar",
    BOTON_ACTUALIZAR: "Actualizar",
    BOTON_COPIAR: "Copiar",
  },
  TituloModal: {
    TITULO_LOGIN: "Login",
    TITULO_CONFIRM_CERRAR_SESION: "Cerrar sesión",
    TITULO_MENSAJE: "Mensaje",

    TITULO_DASHBOARD_LISTA: "Dashboard",
    TITULO_PARAMETER_EDITAR: "Editar Parámetro",
    TITULO_MULTIMEDIA_EDITAR: "Editar Multimedia",
    TITULO_SUBSIDIARY_EDITAR: "Registrar Sucursal",
    TITULO_SUBSIDIARY_EDITAR2: "Editar Sucursal",
    TITULO_MACHINE_REGISTRAR: "Registrar Máquina",
    TITULO_MACHINE_EDITAR: "Editar Máquina",
    // TITULO_APLICACION_REGISTRAR: "Registrar Aplicación",
    // TITULO_APLICACION_ACTUALIZAR: "Actualizar Aplicación",

  },

  MensajeModal: {
    MENSAJE_INFORMACION: "No dejar campos vacíos.",
    MENSAJE_LOGIN: 'Usuario y/o Contraseña incorrecta.',

    MENSAJE_SELECCIONAR_FILA: "Favor de seleccionar una fila.",
    MENSAJE_SELECCIONAR_FILA_PERFIL: "Favor de seleccionar la fila del perfil.",
    MENSAJE_SELECCIONAR_REGISTRO_ESTADO_ACTIVO: "Favor de seleccionar un registro con estado activo.",

    MENSAJE_PARAMETER_ACTUALIZAR: "Se ha actualizado el parámetro satisfactoriamente.",

    MENSAJE_MULTIMEDIA_ACTUALIZAR: "Se ha actualizado la multimedia satisfactoriamente.",
    MENSAJE_MULTIMEDIA_ACTUALIZAR_IMAGEN_VACIA: "Debe adjuntar una imagen/video.",

    MENSAJE_SUBSIDIAR_REGISTRAR: "Se ha registrado la sucursal satisfactoriamente.",
    MENSAJE_SUBSIDIARY_ACTUALIZAR: "Se ha actualizado la sucursal satisfactoriamente.",

    MENSAJE_MACHINE_REGISTRAR: "Se ha registrado la máquina satisfactoriamente.",
    MENSAJE_MACHINE_ACTUALIZAR: "Se ha actualizado la máquina satisfactoriamente."

  },

  QuestionModal: {
    QUESTION_CERRAR_SESION: "¿Estás seguro que deseas cerrar sesión?",
    QUESTION_REGISTRAR_APLICACION: "¿Está seguro que desea registrar la aplicación?",
    QUESTION_ACTUALIZAR_APLICACION: "¿Está seguro que desea actualizar los datos de la aplicación?",
    QUESTION_REGISTRAR_MODULO: "¿Está seguro que desea registrar el módulo?",
    QUESTION_ACTUALIZAR_MODULO: "¿Está seguro que desea actualizar los datos del módulo?",
    QUESTION_REGISTRAR_SUCURSAL: "¿Está seguro que desea registrar la sucursal?",
    QUESTION_ACTUALIZAR_SUCURSAL: "¿Está seguro que desea actualizar los datos de la sucursal?",
    QUESTION_REGISTRAR_OPCION: "¿Está seguro que desea registrar la opción?",
    QUESTION_ACTUALIZAR_OPCION: "¿Está seguro que desea actualizar los datos de la opción?",
    QUESTION_REGISTRAR_USUARIO: "¿Está seguro que desea registrar al usuario?",
    QUESTION_ACTUALIZAR_USUARIO: "¿Está seguro que desea actualizar los datos del usuario?",
    QUESTION_REGISTRAR_DISPOSITIVO: "¿Está seguro que desea registrar el dispositivo?",
    QUESTION_ACTUALIZAR_DISPOSITIVO: "¿Está seguro que desea actualizar los datos del dispositivo?",
    QUESTION_REGISTRAR_ACCION: "¿Está seguro que desea registrar la acción?",
    QUESTION_ACTUALIZAR_ACCION: "¿Está seguro que desea actualizar los datos de la acción?",

    QUESTION_REGISTRAR_PERFIL: "¿Está seguro que desea agregar el perfil?",
    QUESTION_ACTUALIZAR_PERFIL: "¿Está seguro que desea actualizar el perfil?",
    QUESTION_COPIAR_PERFIL: "¿Está seguro que desea copiar el perfil?",
    QUESTION_ACCESO_PERFIL: "¿Está seguro que desea brindar acceso al perfil?",
  },

  Session: {
    SESSIONUSER: "currentUser"
  },

  error: {
    ERRRO_HTTP: "Ha ocurrido un error",
    ERROR_VALIDATIONS: "El código de campaña es duplicado.",
    ERROR_GET_PAGE_SIZE_PAGINATION: "Ha ocurrido un error al obtener la cantidad de filas por paginado, se le asignara 10 filas por pagina.",
    NOT_USER_ACCESS: "El usuario no cuenta con acceso a la aplicación.",
    ERROR_GET_DATE_BIRTHDAY: "Ha ocurrido un error al obtener la fecha."
  },

  TipoMensaje: {
    SAVESUCCESSFUL: "saveSuccessful",
    EDITSUCCESSFUL: "editSuccessful",
    SEARCHERROR: "searchError",
    ERROR: "error"
  },

  AplicacionParametros: {
    aplicacionId: 2,
    moduloId: 2,
    paisId: 1,
    paisCode: "CH", 
    sucursalId: 0,
    profileCode: 0
  }
}

export const MessagesConstants = {

  FilterFormDashboard: {
    startDateForm: {
      required: "La fecha de inicio es un campo requerido."
    },
    endDateForm: {
      required: "La fecha de fin es un campo requerido."
    },
    subsidiaryForm: {
      // required: "El código es un campo requerido."
    }
  },
  FilterExportReport: {
    startDateForm: {
      required: "La fecha de inicio es un campo requerido."
    },
    endDateForm: {
      required: "La fecha de fin es un campo requerido."
    }
  },
  ParameterUpdate: {
    codeForm : {
      required: "El código es un campo requerido."
    },
    descriptionForm: {
      required: "La descripción es un campo requerido."
    },
    valueForm: {
      required :"El valor es un campo requerido"
    }
  },
  SubsidiaryAddUpdate: {
    codeForm : {
      required: "El código es un campo requerido."
    },
    descriptionForm: {
      required: "La descripción es un campo requerido."
    },
    codePromForm: {
      required :"El código de promoción es un campo requerido"
    }
  },
  MachineAddUpdate: {
    macForm : {
      required: "La MAC es un campo requerido."
    },
    tiendaForm: {
      required: "La Tienda es un campo requerido."
    },
    numCajaForm: {
      required :"El número de caja es un campo requerido"
    }
  },
  Login :{
    usuarioForm :{
      required : "El usuario es un campo requerido"
    },
    contrasenaForm : {
      required : "La contraseña es un campo requerido"
    }
  }
}
